import { Container } from "react-bootstrap";
import Heros from "../../home_components/heros/components/heros";
import Album from "../../home_components/album/components/album";
import About from "../../home_components/about/components/about";
import Imgfigures from "../../home_components/figures/components/imgFigures";
import Follow from "../../home_components/follow/components/follow";
import InternalLink from "../../home_components/internal_link/components/internal_link";



const Home = () => {
  return (
    <Container fluid className="m-0 p-0 ">
      <Heros/>
      <Album />
      <About />
      <Imgfigures/>
      <Follow/>
      <InternalLink/>
    </Container>
  );
};
export default Home;
